/** One-click "Copy Quote No. for email" — copies the customer-facing quote
 *  number as rich text (Verdana 12pt bold) with a plain-text fallback.
 *  Self-contained icon button; stops row-click propagation so it never opens
 *  the quote by accident (§7). */
import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { copyQuoteNumber } from "@/lib/copyQuoteNumber";

export function CopyQuoteNo({ quoteNo, size = 14, className = "" }) {
  const [done, setDone] = useState(false);
  if (!quoteNo) return null;

  const onCopy = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const ok = await copyQuoteNumber(quoteNo);
    if (ok) {
      setDone(true);
      window.setTimeout(() => setDone(false), 1500);
      toast.success("Copied for email");
    } else {
      toast.error("Could not copy — select the Quote No. manually");
    }
  };

  return (
    <button
      type="button"
      onClick={onCopy}
      data-testid={`copy-quote-no-${quoteNo}`}
      aria-label="Copy quote number"
      title="Copy Quote No. for email"
      className={
        "inline-flex items-center justify-center rounded p-1 text-slate-400 " +
        "hover:text-slate-700 hover:bg-slate-100 focus:outline-none focus:ring-2 " +
        "focus:ring-sky-400 transition-colors " + className
      }
    >
      {done ? <Check size={size} className="text-emerald-600" /> : <Copy size={size} />}
    </button>
  );
}

export default CopyQuoteNo;
